
import { breakpointValues } from '../../../site/js/utils/breakpoint';

const HERO_BRICK_PADDING = 36;

const pushDataLayer = eventData => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(eventData)
}

const trackNarrativeEntry = (heroBrickId, narrativePathId, totalBricks) => {
  pushDataLayer({
    event: 'narrative_entry',
    eventSource: 'aem',
    hero_brick_id: heroBrickId,
    narrative_path_id: narrativePathId,
    total_bricks_count: totalBricks,
  })
}

const alignHeroBrickWithLogo = () => {
  const heroBrickContents = document.querySelectorAll('.hero-brick__content');
  const headerLogo = document.querySelector('.cmp-header__logo');

  if (!headerLogo || heroBrickContents.length === 0) {
    return;
  }

  const logoRect = headerLogo.getBoundingClientRect();
  const logoLeftOffset = logoRect.left;

  const isMobile = window.innerWidth <= breakpointValues.downLg;
  const paddingValue = isMobile ? HERO_BRICK_PADDING : logoLeftOffset;

  heroBrickContents.forEach((content) => {
    content.style.paddingLeft = `${paddingValue}px`;
    content.style.paddingRight = `${paddingValue}px`;
  });
};

const initHeroBrickRuntime = (container, index, totalBricks) => {
  const linkElement = container.querySelector('a.hero-brick[href]')

  if (!linkElement) {
    return
  }

  const url = linkElement.getAttribute('href')
  if (!url || url.trim() === '' || url === '#') {
    return
  }

  container.style.cursor = 'pointer'

  // Generate hero brick id (sequential)
  const heroBrickId = `hero_brick_${index + 1}`

  // Get narrative path id from the URL
  const narrativePathId = url

  // Track narrative entry on load with total count
  trackNarrativeEntry(heroBrickId, narrativePathId, totalBricks)

  // Add keyboard accessibility to hero-brick__link
  const heroBrickLink = container.querySelector('.hero-brick__link')
  if (heroBrickLink) {
    heroBrickLink.setAttribute('tabindex', '0')
    heroBrickLink.setAttribute('role', 'link')
    heroBrickLink.setAttribute('aria-label', `Navigate to ${heroBrickId}`)

    // Handle keyboard events
    heroBrickLink.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        if (e.ctrlKey || e.metaKey) {
          window.open(url, '_blank')
        } else {
          window.location.href = url
        }
      }
    })
  }

  // Keep click handlers for navigation
  container.addEventListener('click', e => {
    // Allow right-click and middle-click for native browser context menu
    if (e.button === 2 || e.button === 1) {
      return
    }

    const isViewStoryClick = e.target.closest('.hero-brick__link')
    const isImageClick = e.target.closest('a.hero-brick')

    if (isViewStoryClick) {
      e.preventDefault()
      e.stopPropagation()

      if (e.ctrlKey || e.metaKey) {
        window.open(url, '_blank')
      } else {
        window.location.href = url
      }
      return
    }

    if (isImageClick) {
      return
    }

    e.preventDefault()
    e.stopPropagation()

    if (e.ctrlKey || e.metaKey) {
      window.open(url, '_blank')
    } else {
      window.location.href = url
    }
  })

  // Ensure context menu is always allowed
  container.addEventListener('contextmenu', e => {
    // Let the native context menu appear
    e.stopPropagation()
  })
}

const initHeroBrick = (container, index, totalBricks) => {
  if (!('IntersectionObserver' in window)) {
    initHeroBrickRuntime(container, index, totalBricks)
    return
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          initHeroBrickRuntime(entry.target, index, totalBricks)
          obs.unobserve(entry.target)
        }
      })
    },
    { rootMargin: '0px 0px 200px 0px' },
  )

  observer.observe(container)
}

const initHeroBricks = () => {
  const heroBrickContainers = document.querySelectorAll('.hero-brick-container')

  const totalBricks = heroBrickContainers.length
  if (totalBricks === 0) {
    return
  }

  heroBrickContainers.forEach((container, index) => {
    initHeroBrick(container, index, totalBricks)
  })

  alignHeroBrickWithLogo()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroBricks);
} else {
  initHeroBricks();
}

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(alignHeroBrickWithLogo, 150);
});

window.addEventListener('orientationchange', () => {
  setTimeout(alignHeroBrickWithLogo, 200);
});